export default "__VITE_ASSET__BQHYxABq__"